import { InvalidSiwfError, ResponseError } from "../errors.js";
export async function verifySiwf({ origin }, options) {
    const response = await fetch(`${origin}/verify-siwf`, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(options)
    });
    if (!response.ok) {
        throw new ResponseError({ status: response.status });
    }
    const data = await response.json();
    if (data.valid === false) {
        throw new InvalidSiwfError(data.message ?? 'unknown');
    }
    return { token: data.token };
}
